// ProtectedRoute.js
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const isLoggedIn = sessionStorage.getItem("mobileNumber");

  return isLoggedIn ? children : <Navigate to="/login" replace />;
}
